import { useEffect, useState } from 'react'

import { fetchAll } from '@/services/units/fetchAll'
import { formatBrDateToIso } from '@/utils/format-br-date-to-iso'

type Filters = {
  idOperadora: string
  dataLiberacao: string
  situacao: string
}

export const useUnitsList = (operator: Filters) => {
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState<any[]>([])
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [currentFilters, setCurrentFilters] = useState<Filters | undefined>(
    undefined
  )
  const [results, setResults] = useState<number>(0)

  useEffect(() => {
    const defaultFilters: Filters = {
      idOperadora: operator.idOperadora,
      dataLiberacao: formatBrDateToIso(operator.dataLiberacao),
      situacao: operator.situacao
    }

    setCurrentFilters(defaultFilters)
    fetchData(defaultFilters)
  }, [])

  const fetchData = async (filtros: Filters) => {
    setIsLoading(true)

    const payload = {
      idOperadora: filtros.idOperadora,
      data: filtros.dataLiberacao,
      situacao: filtros.situacao,
      pagina: page,
      tamanhoDaPagina: limit
    }

    const allData = await fetchAll(payload)
    setTableData(allData.items)
    setResults(allData.total)
    setIsLoading(false)
  }

  const handleFilter = async (filtros: Filters) => {
    setCurrentFilters(filtros)
    await fetchData(filtros)
  }

  const refetch = async () => {
    if (currentFilters) {
      await fetchData(currentFilters)
    }
  }

  const handleLimitChange = (newLimit: number) => {
    setLimit(newLimit)
    setPage(1)
  }

  useEffect(() => {
    if (currentFilters) {
      fetchData(currentFilters)
    }
  }, [page, limit, search])

  return {
    handleFilter,
    handleLimitChange,
    isLoading,
    limit,
    page,
    refetch,
    results,
    search,
    setLimit,
    setPage,
    setSearch,
    tableData
  }
}
